<template>
  <div class="w-full bg-white border-b border-gray-200 shadow-sm">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <div class="flex items-center justify-between gap-4">
        <!-- Icono de PDF -->
        <div class="flex-shrink-0 hidden sm:flex items-center justify-center w-12 h-12 bg-indigo-50 rounded-full">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6M9 16h6" />
          </svg>
        </div>

        <!-- Contenido de texto -->
        <div class="flex-1 min-w-0">
          <p class="text-gray-900 font-bold text-base leading-tight">
            Descarga la guía completa de colivings{{ cityName ? ` en ${cityName}` : ' en España' }}
          </p>
          <p class="text-gray-600 text-sm mt-1 hidden sm:block">
            Precios, zonas, comparativas y consejos de expertos para encontrar los mejores colivings
          </p>
        </div>
        
        <!-- Botones de acción -->
        <div class="flex items-center gap-2 flex-shrink-0">
          <button 
            @click="openLeadMagnet"
            class="inline-flex items-center justify-center gap-2 px-4 py-2 bg-white text-indigo-600 border border-indigo-200 text-sm font-semibold rounded-full hover:bg-indigo-50 hover:shadow-md shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 whitespace-nowrap">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            <span class="hidden sm:inline">Descargar PDF</span>
            <span class="sm:hidden">Descargar</span>
          </button>
          
          <!-- Botón para cerrar el banner -->
          <button 
            @click="closeBanner" 
            class="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors duration-200"
            aria-label="Cerrar banner">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  cityName: {
    type: String,
    default: null
  }
});

const emit = defineEmits(['open-lead-magnet', 'close']);

const openLeadMagnet = () => {
  emit('open-lead-magnet');
};

const closeBanner = () => {
  emit('close');
};
</script>

<style scoped>
/* Animación suave para el banner */
.hover\:shadow-lg:hover {
  transform: translateY(-1px);
}
</style>

